export default __webpack_public_path__ + "static/media/Camion1.d18f5ed8.png";